import {Component, OnInit} from '@angular/core';
import {CrudService} from "@core/shared/services/crud.service";
import {CrudAction} from "@core/shared/models/crud";

@Component({
    selector: 'app-core-page-article-create',
    templateUrl: './page-article-create.component.html',
    styleUrl: './page-article-create.component.scss',
    providers: [
        CrudService
    ],
    standalone: false
})
export class PageArticleCreateComponent implements OnInit {

    constructor(
        private _crudService: CrudService
    ) {}

    ngOnInit() {

        this._crudService.setAction(CrudAction.Create);
    }
}
